import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/usePartnerLinkQrQuery.ts
var r = (r, i) => t({
	queryKey: e.linkQr(i),
	queryFn: () => n.linkQr(r, i),
	enabled: !!r && !!i,
	staleTime: Infinity
});
//#endregion
export { r as usePartnerLinkQrQuery };
